import React from 'react'

/**
 *
 * ⚠️ !!!!!!!!!!!!!!!!!!!!!!! ⚠️ NOTICE ⚠️ !!!!!!!!!!!!!!!!!!!!!!! ⚠️
 *
 * Google forced us to remove our link to these terms for The Game.
 *
 * If you update these, please also update them in the game:
 * https://github.com/West-Australian-Newspapers/the-game
 *
 * ⚠️ !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! ⚠️
 */
const TheWestTermsContent: React.FC = () => {
    return (
        <div>
            <p>
                <i>As at 30 November 2023</i>
            </p>
            <h2>Agreement</h2>
            <ol>
                <li>
                    These are the Terms of Use for all websites, applications
                    and other media (<b>Media</b>) owned or operated by West
                    Australian Newspapers Limited (ABN 98 008 667 632) (
                    <b>WAN, we, us, our</b>).
                </li>
                <br />
                <li>
                    These Terms of Use apply to all users of the Media whether
                    or not the user is a subscriber, is acting in a personal
                    capacity or on behalf of a business, has accessed the Media
                    directly or indirectly including through any means of
                    technology (<b>User, you, your</b>).
                </li>
                <br />
                <li>
                    By accessing a Media each User agrees to be bound by and
                    comply with these Terms of Use. WAN may update these Terms
                    of Use from time to time without notice to Users so you
                    should check the latest version each time you access a Media
                    by clicking on the Terms of Use section.
                </li>
                <br />
                <li>
                    These Terms of Use should be read in conjunction with our
                    Privacy Policy available{' '}
                    <a href="https://sevenwestmedia.com.au/privacy-policies">
                        here
                    </a>{' '}
                    and other applicable terms including:
                    <ol type="a">
                        <li>
                            in the case of subscribers, the Subscription Terms
                            available{' '}
                            <a href="https://subscriber.thewest.com.au/subscription-terms">
                                here
                            </a>
                            ;
                        </li>{' '}
                        {/* TODO; update here */}
                        <li>
                            in the case of advertisers, the Advertising Terms
                            available{' '}
                            <a href="https://advertising.sevenwestmedia.com.au/terms-conditions/">
                                here
                            </a>
                            ;
                        </li>
                        <li>
                            in the case of The Game, The Game Terms available{' '}
                            <a href="https://thegame.com.au/terms">here</a>; and
                        </li>
                    </ol>
                    (<b>Other Terms</b>).
                </li>
                <br />
                <li>
                    If there is any inconsistency between these Terms of Use and
                    one or more Other Terms, the Other Terms will prevail.
                </li>
            </ol>

            <h2>Permitted Use</h2>

            <ol start={6}>
                <li>
                    If you are not a subscriber to a Media we grant you a
                    limited, royalty free, non-exclusive, non-transferable,
                    non-sublicensable, revocable licence to access and view the
                    Media in Australia for the sole purpose of viewing the Media
                    to determine if you would like to become a subscriber to
                    that Media or to access and use services that we may elect
                    to make available to non-subscribers.
                </li>
                <br />
                <li>
                    If you are a subscriber your subscription will be governed
                    by the applicable Other Terms referred to above which will
                    prevail if there is any inconsistency with these Terms of
                    Use. For example in the case of a subscription to our
                    Digital or Print Media the Subscription Terms will prevail.
                </li>
            </ol>

            <h2>Prohibitions</h2>

            <ol start={8}>
                <li>
                    Without WAN’s prior written permission, a User must not
                    modify, copy, distribute, transmit, publicly display,
                    perform, reproduce, publish, license, create derivative
                    works from, transfer or sell any information, data, content
                    or software obtained from the Media including (without
                    limitation) in connection with:
                    <ol type={'a'}>
                        <li>
                            press clipping or media monitoring services
                            including providing archived or cached data sets
                            containing our content to another person or entity;
                        </li>
                        <li>price comparison websites; or</li>
                        <li>
                            the development of any software program including to
                            train a machine learning or artificial intelligence
                            (AI) system.
                        </li>
                    </ol>
                    <br />
                    For licensing inquiries please contact us at{' '}
                    <a href="mailto:syndication@wanews.com.au">
                        syndication@wanews.com.au
                    </a>
                    .
                </li>
                <br />
                <li>
                    You acknowledge and agree that the Media are ad funded and
                    you must not use any ad blocking technology to block
                    advertising being served via our Media. You may adjust your
                    cookies settings via our Cookies Policy{' '}
                    <a href="https://www.sevenwestmedia.com.au/cookies-guide/">
                        here
                    </a>
                    .
                </li>
            </ol>

            <h2>Third Party Links</h2>

            <ol start={10}>
                <li>
                    If a Media displays any links to third party websites you
                    acknowledge and agree that:
                    <ol type="a">
                        <li>
                            WAN may receive commission when you click through to
                            certain affiliate websites;
                        </li>
                        <li>
                            in clicking on the link you will leave the Media and
                            WAN has no control over those third party websites;
                        </li>
                        <li>
                            you access and use third party websites, goods and
                            services at your own risk; and
                        </li>
                        <li>
                            you may be required to agree to terms and conditions
                            and privacy policies for each third party site.
                        </li>
                    </ol>
                </li>
            </ol>

            <h2>Disclaimers</h2>

            <ol start={11}>
                <li>
                    The content on each Media is provided to you “as is” and on
                    an “as available” basis and on the condition that you
                    undertake all responsibility for assessing the accuracy of
                    the content and rely on it at your own risk.
                </li>
                <br />
                <li>
                    Content included on any Media is prepared as general
                    information only. It is not advice and should not be
                    substituted for personal advice which takes into account
                    your individual health, financial or other circumstances.
                </li>
            </ol>

            <h2>Liability</h2>

            <ol start={13}>
                <li>
                    Except to the extent required under applicable laws
                    including the Australian Consumer Law, WAN excludes all
                    liability arising from or in connection with your use of any
                    Media.
                </li>
            </ol>

            <h2>The Independent Media Council</h2>

            <ol start={14}>
                <li>
                    For any complaints regarding news content on any Media
                    please contact The Independent Media Council&nbsp;
                    <a href="http://www.independentmediacouncil.com.au/">
                        here
                    </a>
                    .
                </li>
            </ol>

            <h2>Severability</h2>

            <ol start={15}>
                <li>
                    If any provision of these Terms of Use is deemed to be
                    invalid by a court of competent jurisdiction, the invalidity
                    of that provision will not affect the validity of the
                    remaining provisions of these Terms of Use, which will
                    remain in full force and effect.
                </li>
            </ol>

            <h2>No waiver</h2>

            <ol start={16}>
                <li>
                    A delay by a party in exercising a right will not amount to
                    a waiver of that right.
                </li>
            </ol>

            <h2>Governing law</h2>

            <ol start={17}>
                <li>
                    These Terms of Use are governed by the laws of Western
                    Australia, Australia, and you irrevocably and
                    unconditionally submit to the non-exclusive jurisdiction of
                    the courts of Western Australia, Australia.
                </li>
            </ol>
            <br />
        </div>
    )
}

export default TheWestTermsContent
